import { useQuery } from '@tanstack/react-query';
import { useApi, useAuth } from '../../hooks';
import { NutritionBlockType } from '../../models/block';
import type { NutritionBlockData } from '../../models/nutritionBlockData';

type Props = {
  eliminationOrUserBlockId: string;
  enabled?: boolean;
  userId: string;
};

export const useElimination = ({
  eliminationOrUserBlockId,
  enabled = true,
  userId,
}: Props) => {
  const { api } = useApi();
  const { isAuthenticated, loading, userToken } = useAuth();

  const fetchElimination = async (): Promise<
    NutritionBlockData<NutritionBlockType.EliminationChallenge>
  > => {
    return await api({
      route: `/private/dashboard/user/${userId}/elimination/${eliminationOrUserBlockId}`,
      token: userToken,
    });
  };

  const { data, isLoading, isError } = useQuery<
    NutritionBlockData<NutritionBlockType.EliminationChallenge>,
    Error
  >({
    queryKey: ['elimination', userToken, userId, eliminationOrUserBlockId],
    queryFn: fetchElimination,
    enabled:
      enabled &&
      isAuthenticated &&
      !loading &&
      !!userToken &&
      !!userId &&
      !!eliminationOrUserBlockId,
    refetchOnWindowFocus: false,
  });

  return {
    elimination: data ?? null,
    isLoading,
    isError,
  };
};
